import { FilterBarState, FilterBarStateKey } from '.';
import { FilterBarGetters } from './getters';
import { FilterBarMutations } from './mutations';

import loggerService from '@/services/logger.service';
import { RootState } from '@/store';

export interface FilterBarContext {
  state: FilterBarState;
  rootState: RootState;
  getters: FilterBarGetters;
  rootGetters: { [k: string]: any };
  commit: <k extends keyof FilterBarMutations>(mutation: k, payload?: any, config?: { root: boolean }) => any;
  dispatch: (action: string, params?: any, settings?: { root: boolean }) => Promise<any>;
}

const actions = {
  updateFilters(context: FilterBarContext, payload: any) {
    if (payload.key !== 'currentPage') {
      payload.resetPagination = true;
    }
    context.commit<any>('sidebar/setmessagelistpage', 1, { root: true });
    context.commit('updateFilters', payload);
    return context.dispatch('loadData', payload);
  },
  toggleFilters(context: FilterBarContext, payload: any) {
    context.commit('toggleFilters', payload);
  },
  clearFilters(context: FilterBarContext, payload: any) {
    context.commit('clearFilters', payload);
    return context.dispatch('loadData', payload);
  },
  async loadNextPage(
    context: FilterBarContext,
    {
      page,
      firstLoad,
      setAsCurrentPage = true
    }: {
      page: FilterBarStateKey;
      firstLoad: boolean;
      setAsCurrentPage: boolean;
    }
  ) {
    const routes = page.split('-');
    //@gc-todo: remove this hack
    const newPage = routes.length >= 2 ? routes[1] : routes[0];
    const currentPage = firstLoad ? 0 : (context.getters.filters(newPage) as any).currentPage || 0;
    const resp = await context.dispatch('loadPage', {
      page: newPage,
      value: setAsCurrentPage ? currentPage + 1 : currentPage
    });

    if (firstLoad) {
      context.commit('updateFilters', {
        page: newPage,
        key: 'totalCount',
        value: resp.count
      });
    }

    return resp;
  },
  loadPage(context: FilterBarContext, { page, value }: { page: FilterBarStateKey; value: number }) {
    return context.dispatch('updateFilters', {
      page,
      key: 'currentPage',
      value
    });
  },
  async loadData(context: FilterBarContext, { page }: { page: FilterBarStateKey }) {
    const routes = page.split('-');
    //@gc-todo: remove this hack
    const newPage = routes.length >= 2 ? routes[1] : routes[0];
    if (newPage === 'EventAgendaPage') {
      return;
    }
    if (newPage === 'StageScreenSaver') {
      return;
    }
    context.commit('updateFilters', { page: newPage, key: 'loading', value: true });
    try {
      const resp = await context.dispatch(`load${newPage}`, { page: newPage });

      context.commit('updateFilters', {
        page: newPage,
        key: 'count',
        value: resp.count
      });
      context.commit('updateFilters', { page: newPage, key: 'loading', value: false });
      context.commit('updateFilters', {
        page: newPage,
        key: 'failedToLoad',
        value: false
      });
      return resp;
    } catch (e) {
      loggerService.error('Failed to load users: ', e);
      context.commit('updateFilters', {
        page: newPage,
        key: 'failedToLoad',
        value: true
      });
    }
  },
  async loadEventNetwork(context: FilterBarContext, { page }: { page: FilterBarStateKey }) {
    const resp = await context.dispatch(
      'event/loadParticipants',
      {
        ...(context.getters.dataLoadRequestParams as any)(page),
        page: 'EventNetwork',
        entered: true
      },
      { root: true }
    );
    return resp;
  },
  async loadSidebarMessage(context: FilterBarContext, { page }: { page: FilterBarStateKey }) {
    const resp = await context.dispatch(
      'event/loadParticipantsWithoutBlanking',
      {
        ...(context.getters.dataLoadRequestParams as any)(page),
        page: 'SidebarMessage',
        entered: true
      },
      { root: true }
    );
    return resp;
  },
  async loadDiscussionGroups(context: FilterBarContext, { page }: { page: FilterBarStateKey }) {
    const resp = await context.dispatch(
      'event/loadDiscussionGroups',
      (context.getters.dataLoadRequestParams as any)(page),
      { root: true }
    );
    context.dispatch('mattermost/getDiscussionGroupWithoutLoader', context.rootState.event.event, {
      root: true
    });
    return resp;
  },
  async loadEventBoothsGridPage2(context: FilterBarContext, { page }: { page: FilterBarStateKey }) {
    const boothsResponse = await context.dispatch(
      'event/loadEventBoothsGridPage2',
      {
        event: context.rootState.route.params.eventID,
        booth_type: 'Secondary',
        ...(context.getters.dataLoadRequestParams as any)(page)
      },
      { root: true }
    );
    return boothsResponse;
  },
  async loadEventBoothsGridPage(context: FilterBarContext, { page }: { page: FilterBarStateKey }) {
    const boothsResponse = await context.dispatch(
      'event/loadEventBoothsGridPage',
      {
        event: context.rootState.route.params.eventID,
        booth_type: 'Primary',
        ...(context.getters.dataLoadRequestParams as any)(page)
      },
      { root: true }
    );
    return boothsResponse;
  }
};

export default actions;
